import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  fallback?: string;
  size?: number;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
  fallback = '/',
  size = 20,
  className = 'p-1 hover:bg-gray-100 rounded',
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Popup pencere → kapat
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }
    // Normal sayfa — history varsa geri, yoksa fallback
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button onClick={handleClick} className={className} type="button">
      <ArrowLeft size={size} />
    </button>
  );
};
